export default "__VITE_ASSET__D0TxzaNO__"